
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import ColorScaleCompService from '@/services/ColorScaleComp.service';
import * as Tone from "tone";

const namespace = "StepSequencerModule";

@Component
export default class StepSequencer extends Vue {
  @Action('setChords', { namespace }) private setChords!: () => any;
  @Action('updateChord', { namespace }) private updateChord!: () => any;
  @Action('nextChord', { namespace }) private nextChord!: () => any;
  @Mutation ("setSelected", { namespace }) private setSelected!: (value: any) => any;
  @Mutation ("setStarted", { namespace }) private setStarted!: (value: boolean) => any;
  @State ("chords", { namespace }) private chords!: number[][];
  @State ("colors", { namespace }) private colors!: string[];
  @State ("selected", { namespace }) private selected!: any[];
  @State ("currentChord", { namespace }) private currentChord!: number[];
  @State ("currentChordN", { namespace }) private currentChordN!: number;
  @State ("started", { namespace }) private started!: number;
  @State ("synth", { namespace }) private synth!: any;
  @State ("notes", { namespace }) private notes!: string[];
  
  private created(){
    this.setStarted(false);
    const value : any[] = [];
    for(let i=0; i<8; i++){
      value[i] = [];
      for(let j=0; j<4; j++){
        value[i][j] = false;
      }
    }
    value[0][0] = true;
    value[4][0] = true;
    value[1][1] = true;
    value[4][1] = true;
    value[2][2] = true;
    value[5][2] = true;
    value[0][3] = true;
    value[3][3] = true;
    this.setSelected(value);
    this.updateChord();
    this.play();
  }

  private getColor(i: number, j: number){
    if(this.selected[i][j]){
      return this.colors[i];
    }
    return "#ddd";
  }

  private getCanvasGradient():string{
    let value = 'linear-gradient(to right, black, ';
    for(const i in this.currentChord){
      value += this.colors[this.currentChord[i]] + ', ';
    }
    value += ' black)'
    return value ;
  }

  private getBarStyle(n: number):string{
    return this.currentChordN!==n ? "#fff" : "#000";
  }

  private handleClick(k: number, l: number){
    if(!this.started){
      Tone.context.resume();
      this.setStarted(true);
    }
    const array : any[] = [];
    for(let i=0; i<8; i++){
      array[i] = [];
      for(let j=0; j<4; j++){
        array[i][j] = this.selected[i][j];
      }
    }
    array[k][l] = !this.selected[k][l];
    this.setSelected(array);
    this.setChords();
    this.updateChord();
  }

  private play():any{
    this.nextChord();
    if(this.started){
      for(const note in this.currentChord){
        this.synth.triggerAttackRelease(this.notes[this.currentChord[note]], "4n");
      }
    }
    if(this.$route.name=="ArticleDisplay"){
      setTimeout(this.play, 1000)
    }
   
  }
}

